import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { LocationDataPropsType } from 'src/views/Service/Location'
import { RootState } from 'src/store/store'
import { commonUtils } from 'src/utils/common.utils'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import Spinner from 'src/components/atomic/atom/Spinner'
import NumberMarker from 'src/components/atomic/atom/NumberMarker'
import { setMapCenterPosition } from 'src/store/Reducer/page/locationPageSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
const LocationHaveHistory = (props: { data: LocationDataPropsType }) => {
  const dispatch = useAppDispatch()
  const { setMediaStyle } = useMediaQueryHook()
  const { convertData, onLocationHistoryClick, locationTypeText } = props.data
  const { LocationInfos } = useAppSelector((state: RootState) => state.locationHistory)
  const { selectPin } = useAppSelector((state: RootState) => state.LocationPage)
  const { setDateFormat } = commonUtils
  const covertLocationData = convertData(LocationInfos).reverse()

  return (
    <Div $margin={'0 0 64px 0'}>
      {covertLocationData?.length === 0 ? (
        <Div height={'300px'}>
          <Spinner $top={'50%'} />
        </Div>
      ) : (
        <>
          {covertLocationData?.map((element, index) => (
            <Div key={index} display={'block'}>
              <Span
                option={setMediaStyle('medium_bold', 'small_bold', 'small_bold')}
                $text_align={'left'}
                color={COLOR.black60}
              >
                {element.date}
              </Span>
              {element?.filterData?.reverse()?.map((fData, index) => (
                <Div key={index} height={'106px'} $margin={'5px 0 0 0'} display={'block'}>
                  <Div display={'flex'} height={'56px'} $gap={'17.5px'} $padding={'16.5px 0'}>
                    <NumberMarker markerText={fData.Idx.toString()} />
                    <Span
                      display={'flex'}
                      option={setMediaStyle('small', 'tiny', 'tiny')}
                      $text_align={'left'}
                      color={COLOR.black50}
                    >
                      {setDateFormat('LOCATION_TIME', fData?.Date as number)}
                    </Span>
                  </Div>
                  <Div height={'50px'} display={'flex'}>
                    <Div
                      width={'1px'}
                      height={'44px'}
                      $margin={'3px 24px 3px 10px'}
                      $border={`1px solid ${COLOR.black20}`}
                    />
                    <Div
                      display={'flex'}
                      $gap={'14px'}
                      width={'100%'}
                      $border_radius={'10px'}
                      $bgColor={fData.Idx === selectPin?.Idx ? COLOR.black2 : 'unset'}
                      onClick={() => {
                        onLocationHistoryClick(fData)
                        dispatch(
                          setMapCenterPosition({
                            lat: Number(fData.XVal),
                            lng: Number(fData.YVal),
                          }),
                        )
                      }}
                      className={'location_history'}
                    >
                      <Svg name={locationTypeText[fData?.Type]?.svgName} $margin={'13px 0'} />
                      <Span
                        option={setMediaStyle('small', 'tiny', 'tiny')}
                        $text_align={'left'}
                        display={'flex'}
                        $align_items={'center'}
                      >
                        {locationTypeText[fData?.Type].text}
                      </Span>
                      <Svg name={'arrow'} $margin={'16px 20px 16px 0'} />
                    </Div>
                  </Div>
                </Div>
              ))}
            </Div>
          ))}
        </>
      )}
    </Div>
  )
}

export default LocationHaveHistory
